export const defaultWebsiteSections = {
  hero: true,
  domainSearch: true,
  featuredProject: true,
  partners: true,
  about: true,
  whyChooseUs: true,
  services: true,
  portfolio: true,
  testimonials: true,
  riyoPos: true,
  contact: true,
  floatingMenu: true,
};

export const websiteSectionOptions = [
  { key: 'hero', label: 'Hero Banner', hint: 'Top banner with main headline and call-to-action.' },
  { key: 'domainSearch', label: 'Domain Search', hint: 'Domain availability search section on the homepage.' },
  { key: 'featuredProject', label: 'Featured Project', hint: 'Highlighted project showcase.' },
  { key: 'partners', label: 'Partners', hint: 'Partner logos carousel.' },
  { key: 'about', label: 'About Company', hint: 'Company mission, vision, and about content.' },
  { key: 'whyChooseUs', label: 'Why Choose Us', hint: 'Feature cards explaining your advantages.' },
  { key: 'services', label: 'Services Overview', hint: 'Homepage services grid.' },
  { key: 'portfolio', label: 'Portfolio Overview', hint: 'Homepage portfolio cards.' },
  { key: 'testimonials', label: 'Testimonials', hint: 'Client testimonials section.' },
  { key: 'riyoPos', label: 'Riyo Pos', hint: 'Riyo Pos integrations / all-in-one POS showcase below testimonials.' },
  { key: 'contact', label: 'Contact', hint: 'Contact information and contact form.' },
  { key: 'floatingMenu', label: 'Floating Action Menu', hint: 'Floating chat and quick action buttons.' },
];

export function normalizeWebsiteSections(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...defaultWebsiteSections };
  }

  return websiteSectionOptions.reduce((acc, option) => {
    const value = raw[option.key];
    acc[option.key] = value !== false;
    return acc;
  }, {});
}

export function isSectionEnabled(sections, key) {
  return sections?.[key] !== false;
}
